import { render, staticRenderFns } from "./PropertyCardsSkeleton.vue?vue&type=template&id=48e7c687"
import script from "./PropertyCardsSkeleton.vue?vue&type=script&lang=js"
export * from "./PropertyCardsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports